import React from 'react'

export default function Success() {
    return(
        <div className='flex flex-col justify-center items-center'>
            <p>Thanks for your response. Continue to LINK to select your flights.</p>
        </div>
    )
}